<template>
  <div id="info">
    <div class="img">
      <img :src="getData.bannerImgUrl" />
    </div>
    <h1 class="air">Lataa opas harjoitteluun!</h1>
    <p class="air">
      Löydät oppaasta paljon hyödyllistä tietoa treenaamisesta! Mukana myös
      usein kysyttyjä kysymyksiä ja tietoa lihaksien rakenteesta ja toiminnasta!
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MainInfo",
  computed: mapGetters(["getData"]),
};
</script>

<style scoped>
#info {
  padding-bottom: 1em;
}
.img {
  margin-bottom: 1em;
}
h1 {
  font-weight: 400;
  margin-bottom: 0.5em;
}
h3 {
  margin-bottom: 0.8em;
}
p {
  margin-bottom: 0.8em;
}
.collapsible-wrapper {
  margin-top: 2em;
  border-radius: 0;
}
.collapsible-btn {
  background: rgba(var(--vs-primary), 0.4);
  color: #fff;
  cursor: pointer;
  padding: 18px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
  font-weight: bold;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}
.collapsible-btn::after {
  content: "\002B";
  font-size: 15px;
  color: white;
  float: right;
  margin-left: 5px;
}
.collapsible-btn.open::after {
  content: "\2212";
}
.collapsible-content {
  padding: 0 1em;
  background: rgba(var(--vs-gray-4), 1);
  color: rgb(var(--vs-text));
  max-height: 0;
  overflow: hidden;
  -webkit-transition: max-height 0.2s ease-out;
  transition: max-height 0.2s ease-out;
  text-align: left;
}
.collapsible-content p {
  margin: 1em 0 0 0;
}
.collapsible-content ul {
  padding: 1em 0 1em 1.3em;
}
p.title {
  font-weight: bold;
}
@media (min-width: 1025px) {
  #info {
    width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
